import { UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import { getAppStoresByUser, patchMatchUserAppStore, patchStoreSwitch } from '@/libs/api/appstore';
import { FetchAppStoreByUserResponse, FetchMatchUserAppStoreRequest, FetchStoreSwitchRequest } from '@/libs/type/interfaces/appstore';
import { UseGetAppStoresByUserOptions } from '@/libs/type/types/appstore';

export const useGetAppStoresByUser = (options?: UseGetAppStoresByUserOptions) => {
  return useQuery<FetchAppStoreByUserResponse[], Error>({
    queryKey: ['getAppStoresByUser'],
    queryFn: getAppStoresByUser,
    ...options
  });
};

export const usePatchMatchUserAppStore = (options?: UseMutationOptions<any, any, FetchMatchUserAppStoreRequest>) => {
  return useMutation({
    mutationFn: (data: FetchMatchUserAppStoreRequest) => patchMatchUserAppStore(data),
    ...options
  });
};

export const usePatchStoreSwitch = (options?: UseMutationOptions<any, any, FetchStoreSwitchRequest>) => {
  return useMutation({
    mutationFn: (data: FetchStoreSwitchRequest) => patchStoreSwitch(data),
    ...options
  });
};
